import { Link } from "react-router-dom";

// Friendly "we couldn't read that" message with a link to the guide for the app the file resembles.
export function ImportErrorHelp({ error, testid = "import-upload-error" }) {
  if (!error) return null;
  const { message, guide, guide_label: label } = typeof error === "string" ? { message: error } : error;
  return (
    <div className="mt-4 text-sm text-red-700 font-semibold" role="alert" data-testid={testid}>
      <p>{message}</p>
      <p className="mt-2 font-normal text-slate-700">
        {guide && label && (
          <><Link to={guide === "evernote" ? "/help/evernote-import" : `/help/import/${guide}`} className="text-rf-orange underline font-semibold" data-testid={`${testid}-guide-link`}>
            Open the {label} step-by-step guide</Link>{" · "}</>
        )}
        <Link to="/help/import" className="text-rf-orange underline" data-testid={`${testid}-hub-link`}>See every import guide</Link>
      </p>
    </div>
  );
}
